import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FaTag } from 'react-icons/fa'
import ConsolidatedPage from '../../pages/PolygonsPage/ConsolidatedPage'
import polygonsService from '../../services/polygonsService'
import { permitsList } from '../../constants/permits'
import { Context } from '../../context/Contex'

const ConsolidatedContainer = () => {
  const [consolidate, setConsolidate] = useState([])
  const history = useHistory()
  const dataTable = []
  const { unidad } = useContext(Context)

  const IdPermiso = permitsList.ADMIN_ZONAS

  /*= =======================================================================
  Get Consolidate
======================================================================== */

  function getConsolidate() {
    polygonsService
      .getConsolidateZones(unidad)
      .then((response) => {
        setConsolidate(response.data.data)
      })
      .catch(() => {
        history.push('/home')
      })
  }

  useEffect(() => {
    getConsolidate()
  }, [unidad])


  try {
    consolidate.forEach((value) => {
      dataTable.push({
        color:
          typeof value === 'object' ? (
            <FaTag
              alt="nophoto"
              style={{ fontSize: 20, color: `${value.COLOR}` }}
            />
          ) : (
            value.COLOR
          ),
        departamento: value.DEPARTAMENTO,
        gerente: value.GERENTE,
        jefe: value.JEFE,
        territorio: value.TERRITORIO,
        municipio: value.MUNICIPIO,
        zona: value.ZONA,
      })
    })
  } catch (err) {
    console.log(err)
  }
  return (
    <>
      <ConsolidatedPage dataTable={dataTable} permits={IdPermiso} />
    </>
  )
}

export default ConsolidatedContainer
